import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { t } from 'ttag';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import SearchIcon from '@material-ui/icons/Search';

export const SearchInput = ({ label, value, onChange }) => {
  const [searchQuery, setSearchQuery] = React.useState(value);
  return (
    <>
      <Grid
        container
        item
        spacing={1}
        justifyContent='flex-start'
        alignItems='center'
      >
        <Grid item sm>
          <TextField
            size='small'
            label={label ? label : t`Пошук`}
            variant='outlined'
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onChange(e.target.value);
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  {searchQuery ? (
                    <IconButton
                      size='small'
                      aria-label='toggle password visibility'
                      onClick={() => onChange(null)}
                      edge='end'
                    >
                      <ClearIcon />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item sm={1}>
          <Tooltip title={t`Застосувати пошук`}>
            <IconButton onClick={() => onChange(searchQuery)}>
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};
